import { Injectable } from '@angular/core';
import { RxapDataSource } from 'eurogard-data-source';
import { GetByFilterToTableMethod } from './get-by-filter-to-table.method';
import { DynamicTableDataSource } from 'eurogard-data-source/table';
import { TypedDashboardTableMethod } from './typed-dashboard-table.method';
import {
  DashboardAutoCompleteResponseResponse,
} from 'open-api-legacy/responses/dashboard-auto-complete-response.response';

@Injectable()
@RxapDataSource('typed-dashboard-table')
export class TypedDashboardTableDataSource extends DynamicTableDataSource<DashboardAutoCompleteResponseResponse> {

  constructor(
    getByFilter: TypedDashboardTableMethod,
  ) {
    super(new GetByFilterToTableMethod(getByFilter));
  }

}
